<template>
	<div>
		<modalconfirm ref="modalconfirmAddOpname" @action="proccessOpname"/>
		<div class="text-h5">Tambah Stok Opname</div>
		<v-card class="mt-3" outlined>
			<v-card-text class="pb-5">
				<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
					{{alert.message}}
				</v-alert>
				<v-row>
					<v-col cols="12" class="py-0">
						<div class="text-body-1 font-weight-bold">Unduh template Stock Opname Disini</div>
						<div class="text-caption">Silahkan unduh template yang kami sediakan, kemudian Anda upload kembali</div>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="6" class="pb-0">
						<v-card elevation="0" color="grey lighten-3">
							<v-col class="pa-0">
								<v-btn height="40" text block class="d-flex justify-space-between" @click="exportTemplateOpname">
									<v-icon>mdi-file-document-outline</v-icon>
									<div class="text-capitalize">Template-Stock-Opname.<span class="text-lowercase">xlsx</span></div>
									<v-icon>mdi-download-outline</v-icon>
								</v-btn>
							</v-col>
						</v-card>
						<v-col cols="12" class="px-0">
							<div class="text-body-1 font-weight-bold">Informasi</div>
							<div class="text-caption">Pastikan untuk mengisi sesuai kolom yang tersedia tanpa merubah formatnya</div>
						</v-col>
					</v-col>
					<v-col cols="6" class="pt-0 mt-n3">
						<div class="pb-1 text-caption font-weight-bold">Upload Data Stock Opname Terbaru Anda</div>
						<v-file-input ref="inputFile" v-model="fileOpname" @change="handleFileUpload($event)" placeholder="Pilih File" outlined dense prepend-icon="" @click:clear="resetFormData" hide-details="auto" class="text-body-2">
							<template v-slot:selection="{ text }">
								<v-chip small label color="primary">
									{{ text }}
								</v-chip>
							</template>
						</v-file-input>
						<div class="pt-5 d-flex justify-end" v-if="false">
							<v-btn small text color="grey darken-1" class="text-capitalize">Batal</v-btn>
							<v-btn small depressed color="grey lighten-3" class="text-capitalize">Upload</v-btn>
						</div>
					</v-col>
				</v-row>
				<v-form ref="formOpname">
					<v-row class="pb-5">
						<v-col cols="12" md="3">
							<v-text-field outlined dense v-model="opname_pic" label="Penanggung Jawab" @focus="() => responseError.pic_name=''" :error-messages="responseError.pic_name" :rules="[inputrules.required]" ></v-text-field>
						</v-col>
						<v-col cols="12" md="3">
							<v-menu v-model="menu" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field outlined dense :value="convertDate(opname_date)" label="Tanggal" prepend-icon="mdi-calendar" readonly @focus="() => responseError.date=''" :error-messages="responseError.date" v-bind="attrs" v-on="on"></v-text-field>
								</template>
								<v-date-picker color="primary" v-model="opname_date"></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<v-textarea v-model="opname_note" label="Catatan" rows="3" height="100" @focus="() => responseError.note=''" :error-messages="responseError.note" hide-details="auto" outlined dense no-resize></v-textarea>
						</v-col>
						<v-col cols="12" class="pb-5">
							<v-simple-table>
								<template v-slot:default>
									<thead class="v-data-table-header">
										<tr>
											<th width="5%" class="text-left">No.</th>
											<th width="40%" class="text-left">Nama Produk</th>
											<th width="10%" class="text-left">Kode Produk</th>
											<th width="10%" class="text-left">Jumlah</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(product, index) in dataImport" :key="index">
											<td>
												<div class="pt-2">{{ index + 1}}</div>
											</td>
											<td>
												<div class="pt-2">{{ product.product_name }}</div>
											</td>
											<td>
												<div class="pt-2">{{ product.product_code }}</div>
											</td>
											<td>
												<div class="pt-2">{{ product.quantity }}</div>
											</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions class="px-4 pb-4" v-if="dataImport.length > 0">
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" depressed class="text-capitalize" @click="addOpname">Proses</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			fileOpname: null,
			menu: false,
			formData: new FormData(),
			opname_pic: '',
			opname_date: '',
			opname_note: '',
			productsSelected: [],
			productRules: value => !!value.product_id || 'Tidak boleh kosong',
		}
	},
	computed: {
		...mapState('stockOpname', ['response', 'responseError', 'alertMultiple', 'dataImport']),
	},
	methods: {
		...mapActions('stockOpname', ['createOpname','importOpname', 'exportTemplateOpname']),
		...mapMutations('stockOpname', ['saveResponse', 'saveImportData', 'clearDataOpname']),
		...mapMutations(['setOverlay']),

		resetFormData() {
			this.formData = new FormData()
			this.saveImportData([])
		},
		handleFileUpload(event) {
			if (event) {
				this.formData.append('excel', event);
			}
			this.import(this.formData)
		},
		import(file) {
			if (file.has('excel')) {
				this.importOpname(file)
			}
		},
		addOpname() {
			if (this.$refs.formOpname.validate()) {
				this.$refs.modalconfirmAddOpname.setMessage('Apakah Anda yakin akan memproses transaksi ini?')
				this.$refs.modalconfirmAddOpname.showConfirm()
			}
		},
		async proccessOpname() {
			await this.setOverlay(true)
			await this.$refs.modalconfirmAddOpname.hideConfirm()
			let params = await {
				product: this.dataImport,
				pic_name: this.opname_pic,
				date: this.opname_date,
				note: this.opname_note
			}
			await this.createOpname(params).then(() => {
				if (this.response.code == 200.) {
					this.resetForm()
				}
			})
			await this.setOverlay(false)
		},
		resetForm(){
			this.saveResponse({
				code: '',
				message: '',
			})
			this.fileOpname = null
			this.saveImportData([])
			this.formData = new FormData()
			this.$refs.formOpname.resetValidation()
			this.opname_date = this.today
			this.opname_note = ''
			this.opname_pic = ''
			this.productsSelected = []
		}
	},
	created() {
		this.opname_date = this.today
		this.$store.dispatch('setPageTitle', `Stok Opname`)
	},
	beforeDestroy() {
		this.clearDataOpname()
	},
	watch: {
	}
}
</script>